import { FC, PropsWithChildren, useEffect } from 'react';

import { destroyBeamer, initBeamer } from 'app/services/beamer';
import { useGetBeamerUserDto } from 'app/services/beamer/hooks';
import { useGeneralDispatch } from 'app/state/GeneralContext/hooks';

// Component Definition
const BeamerProvider: FC<PropsWithChildren> = props => {
  const generalDispatch = useGeneralDispatch();

  const beamerDto = useGetBeamerUserDto();

  useEffect(() => {
    if (beamerDto) {
      initBeamer(
        beamerMessageCount => {
          generalDispatch({
            payload: { beamerMessageCount },
            type: 'setBeamerMessageCount',
          });
        },
        beamerDto,
      );
    } else {
      destroyBeamer();
    }
  },
  [
    beamerDto,
    generalDispatch,
  ]);

  return props.children;
};

export default BeamerProvider;
